/*
 * LeftColumnContainer connects to redux and lays out the edit device, comments, and history
 */

import React from 'react';

import {
    Ifacility,
    IinstallBasePopulated,
    Ijob,
    ImeasurementPointResult,
    IproductInfo,
    IWorkOrder,
    IMPLRwithMeasurementType
} from '../../models';
import { IinitialState } from '../../reducers';

import { Accordion, Button, Card, Row } from 'react-bootstrap';
import { Redirect, RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import { toggleEditInstallModal, installContact } from '../../actions/manageInventoryActions';
import {
    initialFacility,
    initialInstallBase,
    initialInstallBasePopulated,
    initialProduct
} from '../../reducers/initialState';

import { EditInstallContainer } from '../manageInventory/EditInstallContainer';
import { MeasurementPointListCommentForm } from './MeasurementPointListCommentForm';
import { MeasurementPointListResultHistory } from './MeasurementPointListHistory';
import { connect, useSelector } from 'react-redux';
import { getAllMeasurementPointLists } from '../../actions/measurementPointListActions';
import { jobStatusEnum } from '../../models-enums';
import {
    clearHistoricalResultID,
    updateMeasurementPointResult,
    getMeasurementPointListResultHistory
} from '../../actions/measurementPointResultsActions';
import {
    selectInstallBaseHistoryByInstallBaseID,
    selectIsLoading,
    selectIsOnlineAndEmptyQueue
} from '../../reducers/commonReducers';
import { selectIsJobReadOnly, selectIsMPFormLocked, selectJobIDByWorkOrderID } from '../../reducers/commonSelectors';
import { clearSelectedHistoricalWorkOrderID, setSelectedHistoricalWorkOrderID } from '../../actions/workOrderActions';
import InstallContactContainer from '../manageInventory/InstallContactContainer';
import { TestProceduresContainer } from './TestProcedures';
import { ProductLinksContainer } from './ProductLinks';

import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Iprops extends RouteComponentProps<{ installID: string }> {}

interface IdispatchProps {
    selectedInstall: IinstallBasePopulated;
    getAllMeasurementPointLists: typeof getAllMeasurementPointLists;
    loading: boolean;
    productInfo: IproductInfo;
    selectedJob: Ijob;
    facility: Ifacility;
    toggleEditInstallModal: typeof toggleEditInstallModal;
    updateMeasurementPointResult: typeof updateMeasurementPointResult;
    installBaseHistory: Array<IMPLRwithMeasurementType | IWorkOrder>;
    selectedResult: ImeasurementPointResult;
    setSelectedHistoricalWorkOrderID: typeof setSelectedHistoricalWorkOrderID;
    clearSelectedHistoricalWorkOrderID: typeof clearSelectedHistoricalWorkOrderID;
    clearHistoricalResultID: typeof clearHistoricalResultID;
    online: boolean;
    getMeasurementPointListResultHistory: typeof getMeasurementPointListResultHistory;
    isAPIQueueEmpty: boolean;
    isHistoricalMode: boolean;
    jobIDByWorkOrderID: { [workOrderID: string]: string };
    selectedHistoryID: string;
}
interface Istate {
    activeKey: number;
}

const SideLnks = styled.ul`
    width: 100%;
    & > li {
        padding: 10px;
    }
`;

const LeftColumnContainerClass = (props: IdispatchProps & Iprops & WithTranslation) => {
    const isJobReadOnly = useSelector(selectIsJobReadOnly);
    const [state, setState] = React.useState<Istate>({
        activeKey: 1
    });

    const handleSelect = (activeKey: any) => {
        setState({ activeKey });
    };

    const loadHistory = () => {
        props.getMeasurementPointListResultHistory(props.selectedInstall.id);
    };

    const { t } = props;

    // return home if their is no job or the job has been completed
    if (!props.selectedJob.id.length || (props.selectedJob.status === jobStatusEnum.completed && !isJobReadOnly)) {
        return (
            <Redirect
                to={{
                    pathname: '/'
                }}
            />
        );
    }
    return (
        <div>
            <Accordion
                id="measurement-accordian"
                className="measurement-accordian"
                activeKey={String(state.activeKey)}
                onSelect={handleSelect}
            >
                <Card className="mp-accordion-card">
                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="1">
                            {t('leftColumn.commentsAndHistory')}
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="1">
                        <Card.Body>
                            {props.selectedResult.id.length > 0 && (
                                <MeasurementPointListCommentForm {...props} colorButton="primary" showCancel={false} />
                            )}
                            <Button
                                disabled={!props.isAPIQueueEmpty}
                                variant="primary"
                                type="button"
                                onClick={loadHistory}
                            >
                                {t('leftColumn.loadHistory')}
                            </Button>
                            <MeasurementPointListResultHistory
                                clearSelectedHistoricalWorkOrderID={props.clearSelectedHistoricalWorkOrderID}
                                clearHistoricalResultID={props.clearHistoricalResultID}
                                t={props.t}
                                updateMeasurementPointResult={props.updateMeasurementPointResult}
                                installBaseID={props.match.params.installID}
                                installBaseHistory={props.installBaseHistory}
                                setSelectedHistoricalWorkOrderID={props.setSelectedHistoricalWorkOrderID}
                                loading={props.loading}
                                selectedJob={props.selectedJob}
                                jobIDByWorkOrderID={props.jobIDByWorkOrderID}
                                selectedHistoryID={props.selectedHistoryID}
                            />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card className="mp-accordion-card">
                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="2">
                            {t('leftColumn.deviceInfo')}
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="2">
                        <Card.Body>
                            <Row>
                                <EditInstallContainer
                                    selectedItem={props.selectedInstall}
                                    colorButton="primary"
                                    showCancel={false}
                                    history={props.history}
                                    location={props.location}
                                    match={props.match}
                                />
                            </Row>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card className="mp-accordion-card">
                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="3">
                            {t('leftColumn.testProcedures')}
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="3">
                        <Card.Body>
                            <TestProceduresContainer installID={props.match.params.installID} />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card className="mp-accordion-card">
                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="4">
                            {t('leftColumn.contactSupport')}
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="4">
                        <Card.Body>
                            <InstallContactContainer colorButton="primary" installID={props.match.params.installID} />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card className="mp-accordion-card">
                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="5">
                            {t('leftColumn.productLinks')}
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="5">
                        <Card.Body>
                            <ProductLinksContainer colorButton="primary" installID={props.match.params.installID} />
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                <Card className="mp-accordion-card">
                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="6">
                            {t('leftColumn.usefulLinks')}
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="6">
                        <Card.Body>
                            <Row>
                                <SideLnks>
                                    <li>
                                        <a href="https://atlascopco.dezide.com/" target="_blank" rel="noreferrer">
                                            TRAX
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://webmyquest.compressedairbusiness.com/portal/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            MyQuest
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://onevirtualoffice.sharepoint.com/sites/bp_brand_beaconmedaes"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Business Portal BeaconMedas
                                        </a>
                                    </li>
                                </SideLnks>
                            </Row>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </div>
    );
};

const mapStateToProps = (state: IinitialState, ownProps: Iprops) => {
    const jobWorkOrders = Object.values(state.manageJob.jobWorkOrdersByID).filter(
        jwo => jwo.jobID === state.manageJob.selectedJob.id && !jwo.isDeleted
    );
    const install = state.manageInventory.installBasesByID[ownProps.match.params.installID] || initialInstallBase;
    const product = state.manageInventory.productsByID[install.materialID] || initialProduct;
    const installWithProduct: IinstallBasePopulated = {
        ...initialInstallBasePopulated,
        ...install,
        product,
        workOrders: jobWorkOrders
            .filter(jwo => jwo.workOrder?.installBaseID === install.id)
            .map(jwo => jwo.workOrder || state.workOrder.workOrdersByID[jwo.workOrderID]) // sometimes jobWorkOrder.workOrder is undefined
            .filter(wo => wo !== undefined) as IWorkOrder[]
    };

    const installBaseHistory = selectInstallBaseHistoryByInstallBaseID(state, install.id);
    const facility = state.facilities.facilitiesByID[state.manageJob.selectedJob.facilityID] || initialFacility;
    return {
        user: state.user,
        loading: selectIsLoading(state),
        selectedInstall: installWithProduct,
        productInfo: state.productInfo,
        selectedJob: state.manageJob.selectedJob,
        facility,
        installBaseHistory,
        selectedResult: state.measurementPointResults.selectedResult,
        online: state.offline.online,
        isAPIQueueEmpty: selectIsOnlineAndEmptyQueue(state),
        isHistoricalMode: selectIsMPFormLocked(state),
        jobIDByWorkOrderID: selectJobIDByWorkOrderID(state),
        // Whichever history row is open in the overlay - a result or a work order. Both are keyed
        // by the row's own ID, so one value is enough to grey out the rows that are not open.
        selectedHistoryID:
            state.measurementPointResults.historicalResultID || state.workOrder.historicalWorkOrderID
    };
};

export const LeftColumnContainer = withTranslation('measurementPoints')(
    connect(mapStateToProps, {
        getAllMeasurementPointLists,
        toggleEditInstallModal,
        updateMeasurementPointResult,
        setSelectedHistoricalWorkOrderID,
        installContact,
        clearHistoricalResultID,
        clearSelectedHistoricalWorkOrderID,
        getMeasurementPointListResultHistory
    })(LeftColumnContainerClass)
);
